// ─── Workshop Truck Availability Tracker ───
// Settings view – app configuration & preferences
// Placeholder – full implementation in a later step

export default function Settings() {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Settings</h1>
      <p className="text-gray-500">
        Application settings — implementation coming in a later step.
      </p>
    </div>
  )
}
